import clsx from 'clsx'

import type { TagProps } from './types'

const DEFAULT_CLASSNAME = 'inline-flex px-3 py-2 rounded-xs border caption bg-transparent border-brand-800 text-brand-100'
const ACTIVE_CLASSNAME = 'inline-flex px-3 py-2 rounded-xs border caption bg-brand-300 border-brand-300 text-brand-950'

export default function Tag({ label = 'Tag name', href, onClick, isExternal = false, active = false, className }: TagProps) {
	if (href) {
		return (
			<a
				href={href}
				target={isExternal ? '_blank' : undefined}
				rel={isExternal ? 'noopener noreferrer' : undefined}
				className={clsx(active ? ACTIVE_CLASSNAME : DEFAULT_CLASSNAME, !active && 'hover:bg-brand-900', className)}
			>
				{label}
			</a>
		)
	}

	if (onClick) {
		return (
			<button
				type="button"
				onClick={onClick}
				className={clsx(active ? ACTIVE_CLASSNAME : DEFAULT_CLASSNAME, !active && 'hover:bg-brand-900', className)}
			>
				{label}
			</button>
		)
	}

	return <span className={clsx(DEFAULT_CLASSNAME, className)}>{label}</span>
}
